import { createApi } from '@reduxjs/toolkit/query/react'
import {
  IBBL,
  IBBLApplications,
  IBBLBase,
  IBBLSettings,
} from 'shared/models/BBL'
import axiosBaseQuery from 'shared/utils/axiosBaseQuery'
import settleAllQueries from 'shared/utils/settleAllQueries'

const bblApi = createApi({
  reducerPath: 'bbl',
  baseQuery: axiosBaseQuery({ baseUrl: '/bbl/bbl' }),
  endpoints: (build) => ({
    getBbl: build.query<IBBL, void>({
      async queryFn(_arg, _api, _extraOptions, baseQuery) {
        const base = baseQuery({ url: '', method: 'GET' })
        const settings = baseQuery({ url: `/settings`, method: 'GET' })
        const applications = baseQuery({
          url: `/applications`,
          method: 'GET',
        })

        // TODO: TEST SETTLE ALL QUERIES
        const { resolved, rejected } = await settleAllQueries([
          // @ts-expect-error old code
          base,
          // @ts-expect-error old code
          settings,
          // @ts-expect-error old code
          applications,
        ])

        if (rejected.length) {
          return { error: 'Something went wrong' }
        }

        const [baseData, settingsData, applicationsData] = resolved

        const data = {
          ...(baseData as IBBLBase),
          settings: settingsData as IBBLSettings,
          applications: applicationsData as IBBLApplications[],
        }

        return { data }
      },
    }),
  }),
})

export default bblApi
export const { useLazyGetBblQuery } = bblApi
